export default {
  setBuying (state, trades) {
    state.buyingTrades = trades
  },
  setSelling (state, trades) {
    state.sellingTrades = trades
  },
}
